/**
 * Quality Badge Component
 * Displays quality grade with visual styling
 *
 * @author SAUBHAGYA Development Team
 * @since US-BATCH-005
 */

import { Badge } from '@/components/ui/badge';
import { QualityGrade, QualityGradeConfig } from '@/types/inventory';
import { cn } from '@/lib/utils';

interface QualityBadgeProps {
  grade: QualityGrade;
  purity?: number;
  showPurity?: boolean;
  size?: 'sm' | 'md' | 'lg';
  className?: string;
}

export function QualityBadge({
  grade,
  purity,
  showPurity = true,
  size = 'md',
  className
}: QualityBadgeProps) {
  // Get config with fallback for undefined or missing grades
  const config = QualityGradeConfig[grade] || {
    bgColor: 'bg-gray-100',
    color: 'text-gray-700',
    borderColor: 'border-gray-300'
  };

  const sizeClasses = {
    sm: 'text-xs px-2 py-0.5',
    md: 'text-sm px-3 py-1',
    lg: 'text-base px-4 py-1.5'
  };

  return (
    <Badge
      className={cn(
        'font-semibold border',
        config.bgColor,
        config.color,
        config.borderColor,
        sizeClasses[size],
        className
      )}
    >
      <span className="font-bold">Grade {grade || 'Unknown'}</span>
      {showPurity && purity !== undefined && (
        <span className="ml-1.5 font-normal opacity-90">
          • {purity.toFixed(1)}%
        </span>
      )}
    </Badge>
  );
}
